import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) =>
  /* Styles applied to the input element. */
  ({
    title: {
      fontSize: theme.spacing(2),
      fontWeight: theme.typography.fontWeightMedium,
    },
    boldText: {
      fontWeight: theme.typography.fontWeightMedium,
    },
  }),
);
